"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOTE_LOGGER_ENTITY = void 0;
var entity_manager_1 = require("@dch/entity-manager");
var constants_1 = require("../config/constants");
exports.REMOTE_LOGGER_ENTITY = {
    secure: false,
    version: 'v1',
    rel: constants_1.REMOTE_LOGGING_REL,
    url: constants_1.REMOTE_LOGGING_URL,
    timeout: 30000,
    dataStrategy: entity_manager_1.DATASTRATEGY.PROXY_STORAGE,
    storageStrategy: entity_manager_1.STORAGESTRATEGY.NONE,
};
var EntityManagerProviderStrategy = function () {
    var postRequest = function (remoteLogEntity) {
        var entity = entity_manager_1.EntityManager.createEntity(exports.REMOTE_LOGGER_ENTITY, {});
        entity.value = remoteLogEntity;
        return entity_manager_1.EntityManager.saveEntity(entity).toPromise();
    };
    return { postRequest: postRequest };
};
exports.default = EntityManagerProviderStrategy;
